import Datepicker from "../DatePicker";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const DateRangePicker = (props: any) => {
  const { label, setValue, name, getValues } = props;

  const handleValueChange = (newValue: any) => {
    if (newValue?.startDate && newValue.endDate) {
      const formatDateToISO = (date, time, milliseconds = 0) => {
        const d = new Date(date);
        const [hours, minutes, seconds] = time.split(":");
        d.setHours(hours, minutes, seconds, milliseconds);

        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const hh = String(d.getHours()).padStart(2, "0");
        const mm = String(d.getMinutes()).padStart(2, "0");
        const ss = String(d.getSeconds()).padStart(2, "0");
        const ms = String(d.getMilliseconds()).padStart(3, "0");

        return `${year}-${month}-${day}T${hh}:${mm}:${ss}.${ms}`;
      };
      const startDate = formatDateToISO(newValue?.startDate, "00:00:00", 0);
      const endDate = formatDateToISO(newValue?.endDate, "23:59:59", 999);
      console.log(startDate, endDate);
      setValue(name, `${startDate},${endDate}`);
    } else {
      setValue(name, "");
    }
  };

  return (
    <div className={tw`mt-2`}>
      <label htmlFor="" className={tw`-mt-1`}>
        {label}
      </label>
      <div className={tw`mt-1`}>
        <Datepicker
          inputClassName={tw`focus:outline-none bg-[#EEF5F4] w-full p-2`}
          popoverDirection="down"
          value={{
            startDate: getValues()?.[name]?.split(",")?.[0] ?? null,
            endDate: getValues()?.[name]?.split(",")?.[1] ?? null,
          }}
          primaryColor={"pink"}
          onChange={handleValueChange}
          showShortcuts={true}
        />
      </div>
    </div>
  );
};

export default DateRangePicker;
